module.exports = __webpack_public_path__ + "img/iphone.4ecf0372.png";